import { HttpClient } from '@angular/common/http';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  createTranslateLoader,
  GkComponentsModule,
  GkDynamicListModule,
  GkKendoModule,
  GkMapModule,
  RecaptchaService,
} from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  DialogContainerDirective,
  WindowContainerDirective,
} from '@progress/kendo-angular-dialog';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { SharedModule } from '../../shared/shared.module';
import { FreeServicesPortalRoutingModule } from './free-services-portal-routing.module';
import { FreeServicesPortalComponent } from './free-services-portal.component';
import { NewRequestSummaryComponent } from './new-request-summary/new-request-summary.component';
import { NewRequestComponent } from './new-request/new-request.component';
import { FSPNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkDynamicListModule,
    GkMapModule,
    FreeServicesPortalRoutingModule,
    GkComponentsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    DialogContainerDirective,
    WindowContainerDirective,
    GkKendoModule,
    RecaptchaV3Module,
  ],
  declarations: [
    FreeServicesPortalComponent,
    NewRequestComponent,
    NewRequestSummaryComponent,
  ],
  providers: [
    FSPNewRequestFormService,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (recaptchaService: RecaptchaService): string =>
        recaptchaService.siteKey,
      deps: [RecaptchaService],
    },
  ],
})
export class FreeServicesPortalModule {}
